import React, { useState, useEffect } from 'react';
import { Input } from './ui/input';

/**
 * CurrencyInput : saisie de montant, affichage format francais milliers + 2 decimales.
 * Stocke une valeur numerique (float | null) ; affiche "400 000,00 €".
 * Props :
 *   value : number | null | string (valeur stockee)
 *   onChange(number|null)
 *   currency (defaut : € affiche en suffixe)
 *   testId
 */
export function CurrencyInput({ value, onChange, currency = '€', testId, placeholder = '0,00', ...rest }) {
  const [text, setText] = useState('');
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (focused) return;
    if (value === null || value === undefined || value === '') { setText(''); return; }
    const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/\s/g, '').replace(',', '.'));
    if (Number.isNaN(n)) { setText(''); return; }
    setText(new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n));
  }, [value, focused]);

  const parse = (s) => {
    if (!s || !s.trim()) return null;
    const cleaned = s.replace(/\s/g, '').replace(/\u00a0/g, '').replace(',', '.').replace(/[^\d.-]/g, '');
    const n = parseFloat(cleaned);
    return Number.isNaN(n) ? null : n;
  };

  return (
    <div className="relative">
      <Input
        {...rest}
        inputMode="decimal"
        value={focused ? text : text}
        placeholder={placeholder}
        onFocus={() => {
          setFocused(true);
          // afficher sans separateurs pour permettre l'edition simple
          if (value !== null && value !== undefined && value !== '') {
            const n = typeof value === 'number' ? value : parseFloat(String(value));
            if (!Number.isNaN(n)) setText(String(n).replace('.', ','));
          }
        }}
        onChange={(e) => setText(e.target.value)}
        onBlur={() => {
          setFocused(false);
          onChange(parse(text));
        }}
        data-testid={testId}
        className="pr-8"
      />
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-[#5E6D66] pointer-events-none">{currency}</span>
    </div>
  );
}

export default CurrencyInput;
